import React from "react";

export default function LoadingSpinner({width, height}) {
    return (
        <div className="spinner-border m-1" style={{ width: width, height: height}}></div>
    );
}
